import { Theme } from "@screencloud/screencloud-ui-components";
import styled from "styled-components";

export const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 16px 50px;
  background: white;
  border-top: 1px solid #e6e6e6;
  width: 100%;
  flex-shrink: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.05);
  height: 70px;
  align-items: center;
`;

export const FooterContent = styled.div<{
  justifyContent?: "flex-end" | "center" | "space-between";
}>`
  display: flex;
  gap: 16px;
  width: 100%;
  align-items: center;
  justify-content: ${({ justifyContent }) => justifyContent || "flex-end"};
  width: calc(100% - 240px);

  @media (max-width: ${Theme.break.largeHD}) {
    width: calc(100% - 70px);
  }

  @media (max-width: ${Theme.break.small}) {
    width: 100%;
  }
`;
